import React, { Fragment, useRef, useState } from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';

import './PrevencaoPerdas.scss';
import book from '../assets/images/book.png';
import logo from '../assets/images/logo_branca.png';

import successIcon from '../assets/images/check.svg';

const baseURL = process.env.REACT_APP_BASE_URL;

export default function PrevencaoPerdas() {
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [cargo, setCargo] = useState('');

    const [nomeInvalid, setNomeInvalid] = useState(false);
    const [emailInvalid, setEmailInvalid] = useState(false);
    const [empresaInvalid, setEmpresaInvalid] = useState(false);
    const [cargoInvalid, setCargoInvalid] = useState(false);

    const [formInvalid, setFormInvalid] = useState(false);
    const [inscrito, setInscrito] = useState(false);

    const nomeRef = useRef(null);
    const emailRef = useRef(null);
    const empresaRef = useRef(null);
    const cargoRef = useRef(null);

    const captchaRef = useRef(null)

    const submitForm = async (e) => {
        e.preventDefault();

        if (!validaCampos()) return;

        const token = await captchaRef.current.executeAsync();
        captchaRef.current.reset();

        const data = {
            nome,
            email,
            empresa,
            cargo,
            id_ebook: 1,
            token,
            titulo: 'E-book: Introdução à Prevenção de Perdas',
            filename: 'e_book_prevencao_de_perdas.pdf'
        };

        axios.post(`${baseURL}/site/inscricoes`, data).then(() => console.log('enviado'));

        nomeRef.current.value = '';
        emailRef.current.value = '';
        empresaRef.current.value = '';
        cargoRef.current.value = '';

        setFormInvalid(false);
        setInscrito(true);
    };

    const validaCampos = () => {
        if (nome === '') setNomeInvalid(true);
        if (email === '') setEmailInvalid(true);
        if (empresa === '') setEmpresaInvalid(true);
        if (cargo === '') setCargoInvalid(true);

        if (nome === '' || email === '' || empresa === '' || cargo === '') {
            setFormInvalid(true);
            return false;
        }

        return true;
    };

    const handlerChangeNome = (event) => {
        setNome(event.target.value);
        setNomeInvalid(false);
    };

    const handlerChangeEmail = (event) => {
        setEmail(event.target.value);
        setEmailInvalid(false);
    };

    const handlerChangeEmpresa = (event) => {
        setEmpresa(event.target.value);
        setEmpresaInvalid(false);
    };

    const handlerChangeCargo = (event) => {
        setCargo(event.target.value);
        setCargoInvalid(false);
    };

    const closeModal = () => {
        setInscrito(false);
    };

    return (
        <div className="wrapper">
            {inscrito && (
                <Fragment>
                    <div className="overlay" onClick={closeModal} />

                    <div className="overlay_centered">
                        <div className="card">
                            <div className="modal">
                                <img className="success" src={successIcon} alt="icone de sucesso" />

                                <h4>E-book enviado com sucesso!</h4>

                                <p>Você receberá o material no seu e-mail nos próximos minutos.</p>

                                <button type="button" className="success" onClick={closeModal}>
                                    Ok
                                </button>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )}

            <div className="content">
                <div className="content__highlight">
                    <span>eBook gratuito</span>
                    <h2>
                        Por que a <strong>Prevenção de Perdas</strong> é tão <strong>importante</strong> para o seu negócio? 
                    </h2>
                </div>

                <img src={book} alt="ebook imagem" />

                <div className="content__text">
                    <div>
                        <h3>Prevenção de Perdas e sua Importância:</h3>

                        <p>Saiba o que é <strong>Prevenção de Perdas</strong> e entenda como isso pode <strong>impactar o seu negócio</strong>.</p>
                    </div>

                    <div>
                        <h3>Tipos de Perda: </h3>

                        <p>Veja quais são os <strong>tipos de perda</strong> e como <strong>evita-las</strong>.</p>
                    </div>

                    <div>
                        <h3>Simulação de Perdas:</h3>

                        <p>Utilize nossa <strong>ferramenta de simulação</strong>, saiba como as Perdas podem estar <strong>impactando o seu negócio</strong> e quais <strong>planos de ação</strong> você pode adotar.</p>
                        <small>*Dados aproximados calculados com base na pesquisa da ABRAS</small>
                    </div>
                </div>
            </div>

            <div className="contato">
                <div className="contato__descricao">
                    <p>Preencha o formulário e receba o material em seu e-mail!</p>
                </div>

                <form className="form" onSubmit={submitForm}>
                    <div>
                        <label htmlFor="nome">
                            Nome<span>*</span>
                        </label>
                        <input className={nomeInvalid ? 'invalid' : ''} type="text" name="nome" id="nome" ref={nomeRef} onChange={handlerChangeNome} />
                    </div>

                    <div>
                        <label htmlFor="email">
                            E-mail<span>*</span>
                        </label>
                        <input className={emailInvalid ? 'invalid' : ''} type="email" name="email" id="email" ref={emailRef} onChange={handlerChangeEmail} />
                    </div>

                    <div>
                        <label htmlFor="empresa">
                            Empresa<span>*</span>
                        </label>
                        <input
                            className={empresaInvalid ? 'invalid' : ''}
                            type="text"
                            name="empresa"
                            id="empresa"
                            ref={empresaRef}
                            onChange={handlerChangeEmpresa}
                        />
                    </div>

                    <div>
                        <label htmlFor="cargo">
                            Cargo<span>*</span>
                        </label>
                        <input className={cargoInvalid ? 'invalid' : ''} type="text" name="cargo" id="cargo" ref={cargoRef} onChange={handlerChangeCargo} />
                    </div>

                    {formInvalid && <p className="form__invalid">Preencha todos os campos obrigatórios</p>}

                    <ReCAPTCHA sitekey={process.env.REACT_APP_SITE_KEY} ref={captchaRef} size="invisible" />

                    <button type="submit">Quero me inscrever</button>
                </form>

                <img src={logo} alt="logo da empresa" />
            </div>
        </div>
    );
}
